module.exports = __webpack_public_path__ + "img/forgetEmail-img.aec6f8c6.png";